import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-image-column-molecule',
  templateUrl: './image-column-molecule.component.html',
  styleUrls: ['./image-column-molecule.component.scss']
})
export class ImageColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
}
